/**
 * Legacy URL: /sleeve-gastrectomy-surgery-works.
 * Permanent redirect to the canonical sleeve gastrectomy page
 * (/services/sleeve). Intentionally excluded from the sitemap
 * (redirect target only).
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/sleeve-gastrectomy-surgery-works")({
  beforeLoad: () => {
    throw redirect({ to: "/services/sleeve", statusCode: 301, replace: true });
  },
});
